import { Component, input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { DialogFormErrorComponent } from '../dialog-form-error/dialog-form-error.component';
import { AppTooltipComponent } from '../app-tooltip/app-tooltip.component';

@Component({
  selector: 'app-dialog-datepicker',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangePicker,
    MatDateRangeInput,
    MatDatepickerModule,
    DialogFormErrorComponent,
    AppTooltipComponent
  ],
  templateUrl: './dialog-datepicker.component.html'
})
export class DialogDatepickerComponent {
  ctrl = input.required<AbstractControl>();

  startPlaceholder = input<string>();
  endPlaceholder = input<string>();

  minDate = input<Date | null>(null);

  hint = input<string>();

  getDateRangeGroup(): FormGroup {
    const ctrl = this.ctrl();
    return ctrl as FormGroup;
  }

  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }
}
